 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780062973368_COVER from '@/components/text/9780062973368_Cover'
 import LOVE_1 from '@/components/love_1'
 import TEXT9780062973368_TITLEPAGE from '@/components/text/9780062973368_Titlepage'
 import TEXT9780062973368_DEDICATION from '@/components/text/9780062973368_Dedication'
 import TEXT9780062973368_EPIGRAPH from '@/components/text/9780062973368_Epigraph'
 import TEXT9780062973368_CONTENTS from '@/components/text/9780062973368_Contents'
 import TEXT9780062973368_INTRODUCTION from '@/components/text/9780062973368_Introduction'
 import TEXT9780062973368_CHAPTER_01 from '@/components/text/9780062973368_Chapter_01'
 import TEXT9780062973368_CHAPTER_02 from '@/components/text/9780062973368_Chapter_02'
 import TEXT9780062973368_CHAPTER_03 from '@/components/text/9780062973368_Chapter_03'
 import TEXT9780062973368_CHAPTER_04 from '@/components/text/9780062973368_Chapter_04'
 import TEXT9780062973368_CHAPTER_05 from '@/components/text/9780062973368_Chapter_05'
 import TEXT9780062973368_CHAPTER_06 from '@/components/text/9780062973368_Chapter_06'
 import TEXT9780062973368_CHAPTER_07 from '@/components/text/9780062973368_Chapter_07'
 import TEXT9780062973368_CHAPTER_08 from '@/components/text/9780062973368_Chapter_08'
 import TEXT9780062973368_CHAPTER_09 from '@/components/text/9780062973368_Chapter_09'
 import TEXT9780062973368_CHAPTER_10 from '@/components/text/9780062973368_Chapter_10'
 import TEXT9780062973368_CHAPTER_11 from '@/components/text/9780062973368_Chapter_11'
 import TEXT9780062973368_CHAPTER_12 from '@/components/text/9780062973368_Chapter_12'
 import TEXT9780062973368_CHAPTER_13 from '@/components/text/9780062973368_Chapter_13'
 import TEXT9780062973368_CHAPTER_14 from '@/components/text/9780062973368_Chapter_14'
 import TEXT9780062973368_CHAPTER_15 from '@/components/text/9780062973368_Chapter_15'
 import TEXT9780062973368_CHAPTER_16 from '@/components/text/9780062973368_Chapter_16'
 import TEXT9780062973368_CHAPTER_17 from '@/components/text/9780062973368_Chapter_17'
 import TEXT9780062973368_CHAPTER_18 from '@/components/text/9780062973368_Chapter_18'
 import TEXT9780062973368_CHAPTER_19 from '@/components/text/9780062973368_Chapter_19'
 import TEXT9780062973368_CHAPTER_20 from '@/components/text/9780062973368_Chapter_20'
 import TEXT9780062973368_CHAPTER_21 from '@/components/text/9780062973368_Chapter_21'
 import LOVE_2 from '@/components/love_2'
 import TEXT9780062973368_ACKNOWLEDGMENTS from '@/components/text/9780062973368_Acknowledgments'
 import TEXT9780062973368_NOTES from '@/components/text/9780062973368_Notes'
 import TEXT9780062973368_INDEX from '@/components/text/9780062973368_Index'
 import TEXTABOUT_THE_AUTHOR from '@/components/text/About_the_Author'
 import TEXT9780062973368_BA2 from '@/components/text/9780062973368_BA2'
 import TEXT9780062973368_COPYRIGHT from '@/components/text/9780062973368_Copyright'
 import TEXTABOUT_THE_PUBLISHER from '@/components/text/About_the_Publisher'
 import TEXT9780062973368_FOOTNOTE_1 from '@/components/text/9780062973368_Footnote_1'
 import TEXT9780062973368_FOOTNOTE_2 from '@/components/text/9780062973368_Footnote_2'
 import TEXT9780062973368_FOOTNOTE_3 from '@/components/text/9780062973368_Footnote_3'
 import TEXT9780062973368_FOOTNOTE_4 from '@/components/text/9780062973368_Footnote_4'
 import TEXT9780062973368_FOOTNOTE_5 from '@/components/text/9780062973368_Footnote_5'
 import TEXT9780062973368_FOOTNOTE_6 from '@/components/text/9780062973368_Footnote_6'
 import TEXT9780062973368_FOOTNOTE_7 from '@/components/text/9780062973368_Footnote_7'
 import TEXT9780062973368_FOOTNOTE_8 from '@/components/text/9780062973368_Footnote_8'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/9780062973368_Cover",
 			"name" : "text/9780062973368_Cover",
 			"component" : TEXT9780062973368_COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/text/9780062973368_Titlepage",
 			"name" : "text/9780062973368_Titlepage",
 			"component" : TEXT9780062973368_TITLEPAGE
 		},
 		{
 			"path" : "/text/9780062973368_Dedication",
 			"name" : "text/9780062973368_Dedication",
 			"component" : TEXT9780062973368_DEDICATION
 		},
 		{
 			"path" : "/text/9780062973368_Epigraph",
 			"name" : "text/9780062973368_Epigraph",
 			"component" : TEXT9780062973368_EPIGRAPH
 		},
 		{
 			"path" : "/text/9780062973368_Contents",
 			"name" : "text/9780062973368_Contents",
 			"component" : TEXT9780062973368_CONTENTS
 		},
 		{
 			"path" : "/text/9780062973368_Introduction",
 			"name" : "text/9780062973368_Introduction",
 			"component" : TEXT9780062973368_INTRODUCTION
 		},
 		{
 			"path" : "/text/9780062973368_Chapter_01",
 			"name" : "text/9780062973368_Chapter_01",
 			"component" : TEXT9780062973368_CHAPTER_01
 		},
 		{
 			"path" : "/text/9780062973368_Chapter_02",
 			"name" : "text/9780062973368_Chapter_02",
 			"component" : TEXT9780062973368_CHAPTER_02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js